import { render, staticRenderFns } from "./payhead.vue?vue&type=template&id=624fcdd8&scoped=true&"
import script from "./payhead.vue?vue&type=script&lang=js&"
export * from "./payhead.vue?vue&type=script&lang=js&"
import style0 from "./payhead.vue?vue&type=style&index=0&id=624fcdd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624fcdd8",
  null
  
)

export default component.exports